import { Alert } from '@eye-able/ui';
import { T } from '@/i18n/T';

export interface ReadOnlyBannerProps {
  show: boolean;
  className?: string;
}

export function ReadOnlyBanner({ show, className }: ReadOnlyBannerProps) {
  if (!show) return null;

  return (
    <Alert variant='info' className={className}>
      <T k='viewerReadOnlyNotice' />
    </Alert>
  );
}
